import CampaignForm from '@/components/Campaign/CampaignForm/CampaignForm.vue';
import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import ICampaign from '@/interfaces/ICampaign';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Action} from 'vuex-class';

@Component({
    name: 'CampaignDetail',
    components: {
        Loader,
        CardHeader,
        CampaignForm
    }
})
export default class CampaignDetail extends Vue {
    @Action private updateCampaign!: (form: ICampaign) => Promise<string>;
    @Action private getCampaign!: (params: {id: string}) => Promise<ICampaign>;

    private loading: boolean = false;
    private campaignDataFromBackend: ICampaign | null = null;

    private get campaignId() {
        return this.$route.params.id;
    }

    private get formData() {
        if (this.campaignDataFromBackend) {
            return this.transformFormData(this.campaignDataFromBackend);
        }
    }

    private transformFormData(formData:ICampaign) {
        const dataToArray = Object.entries(formData);
        const deviceTypeIdIndex = dataToArray.findIndex(([key, value]) => key === 'deviceTypeId');

        const deviceTypeId = dataToArray.splice(deviceTypeIdIndex, 1);

        if (deviceTypeId.length) {
            dataToArray.splice(4, 0, deviceTypeId[0]);
        }
        
        return dataToArray.reduce((acc: {[key: string]: string | number | boolean | null}, [key, val]) => {
            acc[key] =  val;
            return acc;
        }, {});
    }

    private async campaignUpdate(form: ICampaign) {
        try {
            const removeStatus = await this.updateCampaign(form);
            const location = this.$prevRoute && this.$prevRoute.name === 'campaigns_list' ? this.$prevRoute.fullPath : { name: 'campaigns_list' };

            this.$router.push(location);
            
            this.$notify({
                group: 'notice',
                title: 'Campaign TDS',
                text: removeStatus,
                type: removeStatus
            });
        } catch (error) {
            this.$notify({
                group: 'notice',
                title: 'Error',
                text: error,
                type: 'error'
            });
        }
    }

    private async getCampaignDetail() {
        this.loading = true;
        try {
            this.campaignDataFromBackend = await this.getCampaign({id: this.campaignId});
        } catch (error) {
            console.error(error);
        }
        this.loading = false;
    }

    private async created() {
        try {
            await this.getCampaignDetail();
        } catch(error) {
            console.error(error);
        }
    }
}
